import { createFileRoute, LoaderFnContext } from '@tanstack/react-router';
import { MyRouterContext } from '@/App';
import { InvitationList } from '@/routes/_main/tenant/users/-components/InvitationList';
import { PageHeader } from '@/components/PageHeader';
import { UserInvite } from '@/routes/_main/tenant/users/-components/UserInvite/UserInvite';
import { MainContainer } from '@/components/MainContainer';

export const Route = createFileRoute('/_main/tenant/users/send-invitation')({
  loader,
  component: Component,
});

async function loader({
  context: { adminClient },
}: LoaderFnContext<Record<never, string>, never, MyRouterContext>) {
  const invitations = await adminClient.admin_v1_get_invitations().then((res) => res.items);
  return {
    adminClient,
    invitations,
  };
}

function Component() {
  const { adminClient, invitations } = Route.useLoaderData();

  return (
    <MainContainer>
      <PageHeader title="ユーザの招待" />
      <UserInvite adminClient={adminClient} />
      <div className="mt-20 mb-5 font-bold">承認待ち一覧</div>
      <InvitationList invitations={invitations} adminClient={adminClient} />
    </MainContainer>
  );
}
